/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Role_Sales_Agent_DescInputs */

const en_team_role_sales_agent_desc = /** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create/edit listings and respond to buyer inquiries.`)
};

const es_team_role_sales_agent_desc = /** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puede crear/editar anuncios y responder a compradores.`)
};

const fr_team_role_sales_agent_desc = /** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peut créer/modifier des annonces et répondre aux demandes des acheteurs.`)
};

const de_team_role_sales_agent_desc = /** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann Inserate erstellen/bearbeiten und auf Käuferanfragen antworten.`)
};

const id_team_role_sales_agent_desc = /** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapat membuat/mengedit listing dan menanggapi pertanyaan pembeli.`)
};

/** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */
const ja_team_role_sales_agent_desc = en_team_role_sales_agent_desc;

/** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */
const zh_team_role_sales_agent_desc = en_team_role_sales_agent_desc;

/** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */
const ar_team_role_sales_agent_desc = en_team_role_sales_agent_desc;

/** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */
const it_team_role_sales_agent_desc = en_team_role_sales_agent_desc;

/** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */
const ru_team_role_sales_agent_desc = en_team_role_sales_agent_desc;

/** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */
const pt_team_role_sales_agent_desc = en_team_role_sales_agent_desc;

/** @type {(inputs: Team_Role_Sales_Agent_DescInputs) => LocalizedString} */
const ko_team_role_sales_agent_desc = en_team_role_sales_agent_desc;

/**
* | output |
* | --- |
* | "Create/edit listings and respond to buyer inquiries." |
*
* @param {Team_Role_Sales_Agent_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_role_sales_agent_desc = /** @type {((inputs?: Team_Role_Sales_Agent_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Role_Sales_Agent_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_role_sales_agent_desc(inputs)
	if (locale === "es") return es_team_role_sales_agent_desc(inputs)
	if (locale === "fr") return fr_team_role_sales_agent_desc(inputs)
	if (locale === "de") return de_team_role_sales_agent_desc(inputs)
	if (locale === "ja") return ja_team_role_sales_agent_desc(inputs)
	if (locale === "zh") return zh_team_role_sales_agent_desc(inputs)
	if (locale === "ar") return ar_team_role_sales_agent_desc(inputs)
	if (locale === "id") return id_team_role_sales_agent_desc(inputs)
	if (locale === "it") return it_team_role_sales_agent_desc(inputs)
	if (locale === "ru") return ru_team_role_sales_agent_desc(inputs)
	if (locale === "pt") return pt_team_role_sales_agent_desc(inputs)
	return ko_team_role_sales_agent_desc(inputs)
});